import React from 'react';

/**
 * JOIN BY INVITE CODE (clubs redesign handoff §4) — the black panel under the grid. The button
 * stays dead until there are at least four characters, so a stray tap can't fire a lookup.
 */
export default function InviteCodePanel({ code, onCode, onJoin, busy = false, error = null, phone = false }) {
  const ready = code.trim().length >= 4 && !busy;
  return (
    <div style={{ background: '#000', color: '#fff', padding: phone ? '18px 16px' : '22px 24px', display: 'flex', flexDirection: 'column', gap: 14 }}>
      <span style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.2em', color: '#00FFFF' }}>JOIN BY INVITE CODE</span>
        <span style={{ fontSize: 10, letterSpacing: '0.12em', color: 'rgba(255,255,255,.6)' }}>GOT ONE FROM A HOST? PASTE IT HERE.</span>
      </span>
      <div style={{ display: 'flex', gap: 10, flexWrap: phone ? 'wrap' : 'nowrap' }}>
        <div style={{ flex: '1 1 240px', minWidth: 0, display: 'flex', alignItems: 'center', height: 52, padding: '0 20px', borderRadius: 999, background: '#1A1A1A', boxSizing: 'border-box' }}>
          <input
            type="text"
            value={code}
            onChange={(e) => onCode(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && ready) onJoin(); }}
            placeholder="Enter invite code…"
            aria-label="Invite code"
            style={{ flex: 1, minWidth: 0, border: 'none', background: 'transparent', color: '#fff', fontFamily: 'inherit', fontSize: 15, letterSpacing: '0.12em', textTransform: 'uppercase', padding: 0, outline: 'none' }}
          />
        </div>
        <button
          type="button"
          onClick={onJoin}
          disabled={!ready}
          style={{
            flexShrink: 0,
            height: 52,
            padding: '0 30px',
            border: 'none',
            borderRadius: 999,
            fontFamily: 'inherit',
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: '0.16em',
            width: phone ? '100%' : 'auto',
            background: ready ? '#fff' : '#333',
            color: ready ? '#000' : '#888',
            cursor: ready ? 'pointer' : 'not-allowed',
            transition: 'background-color .2s, color .2s',
          }}
        >
          {busy ? '…' : 'JOIN →'}
        </button>
      </div>
      {error && <span style={{ fontSize: 11, letterSpacing: '0.1em', color: '#FF00AA' }}>{error}</span>}
    </div>
  );
}
